import { version, developer, dateTime } from "./version";
import { useState } from "react";

export default function VersionTag() {
  const [hover, setHover] = useState(false);

  return (
    <div
      style={{ fontSize: "1.1rem", opacity: 0.6, cursor: "default" }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      title={`v${version} by ${developer} @ ${new Date(
        dateTime
      ).toLocaleString()}`}
    >
      {hover
        ? `by ${developer} on ${new Date(dateTime).toLocaleString()}`
        : `v${version}`}
    </div>
  );
}
